(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["almond-announcement"] && !Shopify.designMode) return;
  try {
    
(() => {
  const endsAt = Date.parse('2026-10-16T00:00:00+03:00');
  const expire = () => {
    if (Date.now() < endsAt) return;
    document.querySelectorAll('[data-anniversary-promotion]').forEach(el => { el.hidden = true; el.style.display = 'none'; });
    document.querySelectorAll('[data-anniversary-fallback]').forEach(el => { el.hidden = false; });
  };
  expire();
  const timer = setInterval(() => { if (Date.now() >= endsAt) { expire(); clearInterval(timer); } }, 30000);
  document.addEventListener('visibilitychange', expire);
})();

  } catch(e) { console.error(e); }
})();
})();
